import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { ReactComponent as GarageIcon } from 'assets/icons/ico_garage_black.svg';
import { ReactComponent as ElectricityIcon } from 'assets/icons/ico_electricity_black.svg';
import { ReactComponent as FenceIcon } from 'assets/icons/ico_fence_black.svg';
import { ReactComponent as SunIcon } from 'assets/icons/ico_sun.svg';
import { ReactComponent as DisabilityParkingIconBlack } from 'assets/icons/ico_disability_parking_black.svg';
import { ReactComponent as HeaterChargingIconBlack } from 'assets/icons/ico_engine_heat_black.svg';
import { ReactComponent as CaravanIconBlack } from 'assets/icons/ico_camper_black.svg';
import { ReactComponent as MobileHomeIconBlack } from 'assets/icons/ico_garage_filter_black.svg';
import { ReactComponent as ThreeDotsIcon } from "assets/icons/ico_three_dots_green.svg";
import CheckBox from 'components/common/checkbox/checkbox';

import ItemContextMenu from "components/dashboard/tableItemContextMenu/itemContextMenu";

const ParkingSpotPriceItem = ({
                                  parkingSpot,
                                  setShowEditPriceModal,
                                  setParkingSpotForPrice,
                                  onDeleteSpotPrice,
                                  handleParkingSpotItemPrice,
                              }) => {
    const { t } = useTranslation();
    const [showMenu, setShowMenu] = useState(false);

    if (!parkingSpot) return null;

    const openEditPrice = () => {
        setShowMenu(false);
        setParkingSpotForPrice(parkingSpot);
        setShowEditPriceModal(true);
    };

    const handleDeletePrice = async () => {
        setShowMenu(false);
        if (onDeleteSpotPrice) {
            await onDeleteSpotPrice(parkingSpot);
        }
    };

    return (
        <tr className='h-16 border-b-[1px] border-airpark-gray-300'>
            <td className="pl-6">
                <CheckBox isChecked={parkingSpot.isChecked ?? false} onClick={() => {                                                        
                    if(!parkingSpot.isDisabled){
                        handleParkingSpotItemPrice(parkingSpot);
                    }
                }} />
            </td>
            <td className={`pl-6 ${parkingSpot.isUnavailable ? 'opacity-30' : ''}`}>
                <a href="#" onClick={(e) => { e.preventDefault(); openEditPrice(); }}>
                    {parkingSpot.parkingSpotExtId}
                </a>
            </td>

            <td className={`pl-6 ${parkingSpot.isUnavailable ? 'opacity-30' : ''}`}>
                {parkingSpot.isNumbered ? t('parkingArea.yes') : t('parkingArea.no')}
            </td>

            <td className={`pl-6 ${parkingSpot.isUnavailable ? 'opacity-30' : ''}`}>
                {parkingSpot.floor ?? t('parkingArea.unspecified')}
            </td>

            <td className={`pl-6 ${parkingSpot.isUnavailable ? 'opacity-30' : ''}`}>
                {parkingSpot.isNumbered ? parkingSpot.spotIdentifier : t('parkingArea.notNumbered')}
            </td>

            <td className={`pl-6 ${parkingSpot.isUnavailable ? 'opacity-30' : ''}`}>
                {parkingSpot.objectID || ''}
            </td>

            <td className={`pl-6 ${parkingSpot.isUnavailable ? 'opacity-30' : ''}`}>
                <div className="flex">
                    {parkingSpot.isIndoor ? <GarageIcon className="h-6 w-6" /> : <SunIcon className="h-6 w-6" />}
                    {parkingSpot.hasChargingPost && <ElectricityIcon className="h-6 w-6 ml-2" />}
                    {parkingSpot.isFenced && <FenceIcon className="h-6 w-6 ml-2" />}
                    {parkingSpot.isHeaterCharging &&
                        <HeaterChargingIconBlack className="h-6 w-6 ml-2" />
                    }
                    {parkingSpot.isDisabilityParking &&
                        <DisabilityParkingIconBlack className="h-6 w-6 ml-2" />
                    }
                    {parkingSpot.isCaravan &&
                        <CaravanIconBlack className="h-6 w-6 ml-2" />
                    }
                    {parkingSpot.isMobileHome &&
                        <MobileHomeIconBlack className="h-6 w-6 ml-2" />
                    }
                </div>
            </td>

            <td className={`pl-6 ${parkingSpot.isUnavailable ? 'opacity-30' : ''}`}>
                <div className="flex">
                    {parkingSpot?.price != null &&
                    Number(parkingSpot.price).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })
                    }
                </div>
            </td>

            <td className="border-l-[1px] border-airpark-gray-300 min-w-[72px] w-[72px] relative">
                <button
                    className="flex h-16 w-full justify-center items-center"
                    onClick={(e) => { e.preventDefault(); setShowMenu(!showMenu); }}
                >
                    <ThreeDotsIcon className="block" />
                </button>

                {showMenu && (
                    <ItemContextMenu
                        onCloseClick={() => setShowMenu(false)}
                        onEditClick={openEditPrice}
                        onDeleteClick={parkingSpot?.price != null ? handleDeletePrice : undefined}
                    />
                )}
            </td>
        </tr>
    );
};

export default ParkingSpotPriceItem;
